/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipping_viewer = {
    readonly relevantShipping: {
        readonly quoteRequestStatus: string | null;
    } | null;
    readonly regionalInfo?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_regionalInfo">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_viewer">;
    readonly " $refType": "PdpSharedDetailShipping_viewer";
};
export type PdpSharedDetailShipping_viewer$data = PdpSharedDetailShipping_viewer;
export type PdpSharedDetailShipping_viewer$key = {
    readonly " $data"?: PdpSharedDetailShipping_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relevantShipping",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "RelevantShippingInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "quoteRequestStatus",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchRegionalInfo",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedShippingInfo_regionalInfo",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'aab972b3d99d113751f520b4f6d205d8';
export default node;
